import { render, staticRenderFns } from "./PlatformRegionsPicker.vue?vue&type=template&id=25d02fc5"
import script from "./PlatformRegionsPicker.vue?vue&type=script&lang=js"
export * from "./PlatformRegionsPicker.vue?vue&type=script&lang=js"
import style0 from "./PlatformRegionsPicker.vue?vue&type=style&index=0&id=25d02fc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports